import {createAction, props} from "@ngrx/store";
import {LoginDto, LoginResponseDto} from "../models/auth.model";

export const login = createAction('[Auth] Submit login', props<LoginDto>());

export const clear = createAction('[Auth] Clean state');

export const loginSuccess = createAction('[Auth] Login Success', props<LoginResponseDto>());

export const loginError = createAction('[Auth] Login Failure', props<{ error: string }>());

export const saveToken = createAction('[Auth] save token', props<LoginResponseDto>());

export const logout = createAction('[Auth] Logout');

export const storeTokens = createAction('[Auth] Store tokens and user', props<LoginResponseDto>());

export const logoutSuccess = createAction('[Auth] User logged out');
